import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';
import { ListagemCadastros } from '../interfaces/listagem-cadastros';

@Injectable({
  providedIn: 'root'
})
export class ListagemCadastrosService {

  readonly path = '/listagem_cadastros';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) { }


  create(): Observable<ListagemCadastros> {
    return this.http.post<ListagemCadastros>(`${this.jwtAuthService.apiUrl + this.path}`, null);
  }

  saveOrUpdate(ListagemCadastros: ListagemCadastros): Observable<ListagemCadastros> {
    return this.http.put<ListagemCadastros>(`${this.jwtAuthService.apiUrl + this.path}`, ListagemCadastros);
  }

  getListagemCadastros(id: number ): Observable<ListagemCadastros> {
    return this.http.get<ListagemCadastros>(`${this.jwtAuthService.apiUrl + this.path}/?ListagemCadastrosId=${id}`);
  }

  getListagemCadastrosPage(page?: number, size?: number): Observable<PageResult<ListagemCadastros>> {
    return this.http.get<PageResult<ListagemCadastros>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=${size}`);
  }

  getListagemCadastrosPageSearch(page?: number, size?: number,  search?: string): Observable<PageResult<ListagemCadastros>> {
    return this.http.get<PageResult<ListagemCadastros>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=${size}&search=${search}`);
  }

  deleteListagemCadastros(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }


}
